export default __webpack_public_path__ + "static/Trabajos-453269138066f81c9df0733e1d0b6df1.png";